import { render } from "./MenuTableCreate.vue?vue&type=template&id=02a2d6f8"
import script from "./MenuTableCreate.vue?vue&type=script&lang=js"
export * from "./MenuTableCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__